import React from "react";
import cn from "classnames";
import useContent from "../../helpers/useContent";
import Container from "../../components/Container";
import Content from "../../components/Content";
import Meta from "../../components/Meta";
import SpotlightsList from "../../components/SpotlightsList";
import ExternalLinkList from "../../components/ExternalLinkList";
import { List, OrderedList, Standfirst } from "../../components/Elements";
import s from "./style.module.css";
import { useLocation } from "react-router-dom";

const Header = ({ title, tag }) => (
  <div className={s.header}>
    <Container>
      <div className={s.headerInner}>
        <div></div>
        <h1 className={s.headerTitle}>{title}</h1>
        <p className={s.tag}>{tag}</p>
        <img
          className={s.icon}
          src={`/images/spotlights/icons/${tag}.svg`}
          alt=""
        />
      </div>
    </Container>
  </div>
);

const Story = ({
  meta = {},
  tag,
  title,
  sub,
  content,
  footnotes = [],
  references = [],
  relatedContent,
  additionalComponents,
  allSpotlights,
}) => {
  const items = useContent(content, additionalComponents);

  const { pathname } = useLocation();
  const url =
    process.env.PUBLIC_URL ||
    process.env.DEPLOY_PRIME_URL ||
    "https://wdr2021.worldbank.org";

  const index = allSpotlights.indexOf(
    allSpotlights.find((d) => d.title === title)
  );
  const next = (index + 1) % allSpotlights.length;
  const prev = index - 1 < 0 ? allSpotlights.length - 1 : index - 1;

  return (
    <Meta {...meta} image={"/images/spotlights/share.png"}>
      <div className={s.wrap}>
        <Header title={title} tag={tag} />
        <Container>
          <div className={s.content}>
            <div className={s.standfirst}>
              <Standfirst>{sub}</Standfirst>
            </div>

            {items.length !== 0 && (
              <div className={s.contentArea}>
                <Content items={items} />
              </div>
            )}
          </div>
        </Container>

        <Container>
          <div
            className={cn(s.notes, {
              [s.hasNotes]: footnotes.length !== 0 || references.length !== 0,
            })}
          >
            {footnotes.length !== 0 && (
              <>
                <strong>Notes</strong>
                <OrderedList items={footnotes} id={"notes"} />
              </>
            )}

            {references.length !== 0 && (
              <>
                <strong>References</strong>
                <List items={references} />
              </>
            )}
          </div>
        </Container>

        <div className={s.footer}>
          <Container>
            <div className={s.inner}>
              <div className={s.related}>
                <ExternalLinkList
                  inline
                  simple
                  title="Share"
                  items={[
                    {
                      url: `https://www.twitter.com/intent/tweet?url=${url}${pathname}`,
                      title: "Twitter",
                      icon: "twitter",
                    },
                    {
                      url: `https://www.facebook.com/sharer/sharer.php?u=${url}${pathname}`,
                      title: "Facebook",
                      icon: "facebook",
                    },
                    {
                      url: `https://www.linkedin.com/sharing/share-offsite/?url=${url}${pathname}`,
                      title: "LinkedIn",
                      icon: "linkedin",
                    },
                  ]}
                />
              </div>

              <div className={s.related}>
                <ExternalLinkList
                  simple
                  title="Related content"
                  items={relatedContent || []}
                />
              </div>
            </div>
          </Container>
        </div>
        <div className={s.spotlights}>
          <Container>
            <SpotlightsList
              items={[allSpotlights[prev], allSpotlights[next]]}
            />
          </Container>
        </div>
      </div>
    </Meta>
  );
};

export default Story;
